var React = require('react');

function ArrowButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"15.5","stroke":"#FFD07A","key":0}),React.createElement("path",{"d":"M22 16.5951C22.3314 16.5951 22.6 16.3265 22.6 15.9951C22.6 15.6637 22.3314 15.3951 22 15.3951V16.5951ZM10.5757 15.5709C10.3414 15.8052 10.3414 16.1851 10.5757 16.4194L14.3941 20.2378C14.6284 20.4721 15.0083 20.4721 15.2426 20.2378C15.477 20.0034 15.477 19.6235 15.2426 19.3892L11.8485 15.9951L15.2426 12.601C15.477 12.3667 15.477 11.9868 15.2426 11.7525C15.0083 11.5182 14.6284 11.5182 14.3941 11.7525L10.5757 15.5709ZM22 15.3951L11 15.3951V16.5951H22V15.3951Z","fill":"#FFD07A","key":1})]);
}

ArrowButton.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowButton;

ArrowButton.default = ArrowButton;
